'use strict';

var $ = require('jquery');
var AlertsDrawerDirective = function AlertsDrawerDirective($rootScope) {
  return {
    restrict: 'E',
    template: require('../templates/alerts-drawer.html'),
    controller: 'AlertsDrawerController',
    scope: {
      entityData: '=',
      headerFormat: '@',
      footerItemsFormat: '=',
      mode: '@',
      screen: '@',
      parentGridId: '@',
      parentGridServerSorting: '=',
      reoptPreviewData: '=?'
    },
    link: function link(scope, element) {
      element.on('rowselect', scope.rowSelectionChanged);
      element.on('rowunselect', scope.rowSelectionChanged);
      element.on('click', 'a.readOnlyRule', function (e) {
        e.preventDefault();
        $rootScope.$broadcast('read-only-rule:show', $(this).data('uid'));
        e.stopPropagation();
        return false;
      });
    }
  };
};
AlertsDrawerDirective.$inject = ['$rootScope'];
module.exports = AlertsDrawerDirective;